<template>
  <benefit-notification-box-base :icon-path="'subscription/discount.svg'" :description="description" :title="title"/>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import BenefitNotificationBoxBase from '@/base-components/BenefitNotificationBoxBase';

export default {
  name: 'PercentageDiscountBenefitNotificationBox',
  components: {
    BenefitNotificationBoxBase,
  },
  computed: {
    ...mapState('benefits', ['benefitType', 'benefitAmount', 'benefitPercentage']),
    ...mapGetters('benefits', ['BENEFIT_TYPES', 'discountedPrice', 'monthsText']),
    description() {
      return `${this.monthsText} מינוי ב-₪${this.discountedPrice} (${this.benefitPercentage}% הנחה) ולאחר מכן, ₪45 לחודש `;
    },
    title() {
      return 'מגיעה לך הנחה על דמי המינוי!';
    },
  },
};
</script>

<style scoped lang="scss">
</style>
